import { Component } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { UserStatusBrickBaseComponent } from './user-status-brick.base.component';
import { ISmallBrickComponent } from 'src/app/components/dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';

@Component({
   selector: 'samweb-user-status-brick-small',
   templateUrl: './user-status-brick.small.component.html',
   styleUrls: ['./user-status-brick.small.component.scss'],
})
export class UserStatusBrickSmallComponent extends UserStatusBrickBaseComponent implements ISmallBrickComponent {
   constructor(store: Store) {
      super(store);
   }
}
